'use client';

import {
    buildClassNames,
    mergeClassNames,
} from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { useCallback } from 'react';
import { addToastSuccess } from '@frontend/jetlend-core/src/ducks/toasts';
import { connectFunctionalComponent } from '@frontend/jetlend-core/src/ducks/connect';
import styles from './SocialButtonsList.module.scss';
import VKIcon from '@app/icons/vk.svg';
import telegramIcon from '@app/icons/telegram.svg';
import shareIcon from '@app/icons/share.svg';
import Image from '@app/components/Image/Image';

type AlignType = 'vertical' | 'horizontal'

export const BUTTONS_PROPS = [
    {
        key: 'vk',
        icon: VKIcon,
    },
    {
        key: 'telegram',
        icon: telegramIcon,
        iconClassName: 'button-icon--offset',
    },
    {
        key: 'share',
        icon: shareIcon,
    },
];

const copyLink = () => {
    const clipboard = navigator.clipboard;
    return clipboard.writeText(window.location.href);
};

const getContainerClassName = (align: AlignType, className?: string) => mergeClassNames([
    className,
    buildClassNames(styles, ['social-media', `social-media--${align}`]),
]);

interface IProps {
    className?: string;
    align?: AlignType;
}

type Props = IProps & {
    addToast: typeof addToastSuccess;
}

const SocialButtonsList = (props: Props) => {
    const {
        className,
        align = 'vertical',
        addToast,
    } = props;

    const didIconClicked = useCallback((key: string) => {
        if (key === 'share') {
            copyLink().then(() => addToast('Ссылка скопирована'));
            return;
        }
        const url = encodeURIComponent(window.location.href);

        switch (key) {
        case 'telegram' : {
            window.open(`tg://msg_url?url=${url}`, '_blank');
            break;
        }
        case 'vk': {
            window.open(`https://vk.com/share.php?url=${url}`, '_blank');
            break;
        }
        }
    }, [addToast]);

    return (
        <div className={getContainerClassName(align, className)}>
            {BUTTONS_PROPS.map(item => (
                <button className={styles['button-container']} key={item.key} onClick={() => didIconClicked(item.key)}>
                    <div className={buildClassNames(styles, ['button-icon', item.iconClassName])}>
                        <Image src={item.icon} alt="" fill quality={100} />
                    </div>
                </button>
            ))}
        </div>
    );
};

export default connectFunctionalComponent(SocialButtonsList, {
    dispatch: {
        addToast: addToastSuccess,
    },
});